import { keyframes } from "@emotion/react";
import { Spinner as Icon } from "@mos-cat/ds-icons";
import type { Ref } from "react";
import { forwardRef } from "react";
import { Box } from "../Box/Box";
import type { StylesOptions } from "../hooks/useStyles";

const spin = keyframes({
  from: { transform: "rotate(0deg)" },
  to: { transform: "rotate(359deg)" },
});

const Spinner = forwardRef(({ styles, ...props }: StylesOptions, ref: Ref<SVGSVGElement>) => (
  <Box
    as="span"
    position="absolute"
    top="50%"
    left="50%"
    display="block"
    styles={{
      transform: "translate(-50%, -50%)",
    }}
  >
    <Box
      as="span"
      display="block"
      styles={{
        animation: `${spin} .75s linear 0s infinite normal none running`,
      }}
    >
      <Box
        as={Icon}
        ref={ref}
        styles={{
          ...styles,
        }}
        {...props}
      />
    </Box>
  </Box>
));

export default Spinner;
